export namespace LocalStorageKeys {
  export const LANGUAGE = 'language';
}
